import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH } from "../Config/Config";

const saveCapability = async (capabilityData) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}/KeyLogging/saveCapabilities?companyId=${user.companyid}`,
    capabilityData,
  );

  return response.data;
};

const useSaveCapabilityMutation = (options = {}) => {
  return useMutation({
    mutationFn: saveCapability,
    ...options,
  });
};

export default useSaveCapabilityMutation;
